import React from 'react';
import './NewProduct.css';
import TitleOfSection from '../TitleOfSection';

import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
const NewProduct = ({id, newArrival}) => {
  const { t } = useTranslation();

  return (
    newArrival?.images.length > 0 &&(
    <div>
      <div className='container mb-2'>
        <div className="d-flex justify-content-between align-items-center">
          <div className="text-center">
          <TitleOfSection title={t("newArrivals")} />
          </div>
         
        </div>
      </div>
      <div className="d-flex new-arrived">
         {newArrival?.images?.map((item, index) => (
          <Link to={item?.link}
            key={index}
            className={`banner ${index === 1 ? 'middle' : 'side'}`} 
            style={{ backgroundImage: `url(${item?.secure_url})`, textDecoration: "none" }} 
         
          >
            {/* <p>{banner.title}</p> */}
            <h5>{t("newArrivals")}</h5> 
            {/* <div className="shopping">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.9272 18.8201C14.7372 18.8201 14.5472 18.7501 14.3972 18.6001C14.1072 18.3101 14.1072 17.8301 14.3972 17.5401L19.9372 12.0001L14.3972 6.46012C14.1072 6.17012 14.1072 5.69012 14.3972 5.40012C14.6872 5.11012 15.1672 5.11012 15.4572 5.40012L21.5272 11.4701C21.8172 11.7601 21.8172 12.2401 21.5272 12.5301L15.4572 18.6001C15.3072 18.7501 15.1172 18.8201 14.9272 18.8201Z" fill="white" />
              <path d="M20.83 12.75H4C3.59 12.75 3.25 12.41 3.25 12C3.25 11.59 3.59 11.25 4 11.25H20.83C21.24 11.25 21.58 11.59 21.58 12C21.58 12.41 21.24 12.75 20.83 12.75Z" fill="white" />
            </svg>
              <span>تسوق الان</span> 
            </div> */}
          </Link>
        ))}
      </div>
    </div>

    )
  )
}


export default NewProduct